import React, { useState, useEffect, useRef } from 'react'
import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'
import { MuiButton, TourGuide } from '../../../components'
import { getLogData, getImageUrl, timeStampToDate, fakeDelay } from '../../../util'
import { useGlobalStore } from '../../../store'
import { IconLogoAskIa, IconLogoSnapshot } from '../../../assets/images/icons'
import { IconSandbox } from '../../../assets/images/iconsV2'
import DownloadPpt from './download-ppt'
import DownloadCSV from './download-csv'

import { ROLES_PUBLISHER, ROLES_MM_PRIMARY, ROLES_CLIENT_SECONDARY } from '../../../constants'

import { RhsWrapper } from './style'

const HeaderButtons = (props) => {
  const logoRef = useRef()
  const { user, company, projectIdValue, isFullScreen } = useGlobalStore()
  const pptLogoPath = getImageUrl('ppt', company?.CompanyLogo, 'png')

  const sandBoxClickedFunc = () => {
    document.querySelector('.hideSandBox a').click()
  }

  /////////////////////////////////////////////////
  const { id } = useParams()
  const [headerData, setHeaderData] = useState({})
  const getHeaderInfo = async () => {
    await fakeDelay(1000)
    if(projectIdValue?.StudyId){
      // const projectIdValue = getLogData('GetStudies', 'GetStudies', {}, { StudyId: id })[0]
      const headerLogData = projectIdValue.ProjectId
        ? getLogData('GetProjects', 'GetProjects', {}, { ProjectId: projectIdValue.ProjectId })[0]
        : {}

      projectIdValue['IsAskIAForStudy'] = !!projectIdValue?.AskIA || !!projectIdValue?.IsAskIAEnabled
      projectIdValue['IsSnapshotForStudy'] = !!projectIdValue?.Snapshot || !!projectIdValue?.IsSnapshotEnabled

      const headerObj = {
        studyId: projectIdValue?.StudyId || '',
        breadCrumb: headerLogData?.ProjectType || '',
        title: `${headerLogData?.BrandName || '' || headerLogData?.CategoryName || ''} ${headerLogData?.ProjectType || ''}`,
        subTitle: `${headerLogData?.MarketName || ''} | ${projectIdValue?.Period || ''}`,
        lastUpdated: timeStampToDate(projectIdValue?.ModifiedDate || ''),
      }
      setHeaderData(headerObj)
    }
  }
  
  useEffect(() => {
    getHeaderInfo()
  }, [])
  
  useEffect(() => {
    getHeaderInfo()
  }, [projectIdValue])
  /////////////////////////////////////////////////

  return (
    <RhsWrapper className={`userType_${[ROLES_PUBLISHER].includes(user.UserType)}`}>
      { ROLES_MM_PRIMARY.includes(user.UserType) && !projectIdValue.IsAskIAForStudy && ( <LogoAskIa {...headerData} /> )}
      { ROLES_CLIENT_SECONDARY.includes(user.UserType) && projectIdValue.IsAskIAForStudy && ( <LogoAskIa {...headerData} /> )}

      { ROLES_MM_PRIMARY.includes(user.UserType) && !projectIdValue.IsSnapshotForStudy && ( <LogoSnapshot {...headerData} /> )}
      { ROLES_CLIENT_SECONDARY.includes(user.UserType) && projectIdValue.IsSnapshotForStudy && ( <LogoSnapshot {...headerData} /> )}

      {/* {ROLES_MM_PRIMARY.includes(user.UserType) && (
        <DownloadCSV
          {...headerData}
          fileCount={0}
          logoDetails={{
            logoImg: pptLogoPath,
            logoW: logoRef?.current?.offsetWidth,
            logoH: logoRef?.current?.offsetHeight,
          }}
        />
      )} */}
      {ROLES_CLIENT_SECONDARY.includes(user.UserType) && (
        <DownloadPpt
          {...headerData}
          fileCount={0}
          logoDetails={{
            logoImg: pptLogoPath,
            logoW: logoRef?.current?.offsetWidth,
            logoH: logoRef?.current?.offsetHeight,
          }}
        />
      )}

      <MuiButton
        className={`sandBox ${isFullScreen ? '' : 'n-fullScreen'}`}
        size='small'
        startIcon={<IconSandbox />}
        color='dark'
        variant='contained'
        label='Sandbox'
        onClick={() => sandBoxClickedFunc()}
      />

      {/* {ROLES_CLIENT_SECONDARY.includes(user.UserType) && <TourGuide type='tutorialButton' />} */}
    </RhsWrapper>
  )
}

export default HeaderButtons

const LogoAskIa = () => {
  const { projectIdValue, isAskIaActiveState, setAskIAModalActive, setShowLhsMenu, isFullScreen } = useGlobalStore()
  const askIaActiveStateFunc = () => {
    if (isAskIaActiveState === 'none') {
      setAskIAModalActive(true)
      setShowLhsMenu('reportPage_hideLhs')
    } else {
      // setAskIaActiveState('none')
    }
  }
  
  return (
    <Box className={`BtnAskIA ${isFullScreen ? '' : 'n-fullScreen'}`} style={{ position: 'relative' }}>
      <MuiButton
        variant='text'
        color='light'
        onClick={() => askIaActiveStateFunc()}
      >
        <IconLogoAskIa />
      </MuiButton>
    </Box>
  )
}

const LogoSnapshot = () => {
  const { projectIdValue, isSnapshotActiveState, setSnapshotModalActive, setShowLhsMenu, isFullScreen } = useGlobalStore()
  const snapshotActiveStateFunc = () => {
    if (isSnapshotActiveState === 'none') {
      setSnapshotModalActive(true)
      setShowLhsMenu('reportPage_hideLhs')
    } else {
      // setSnapshotActiveState('none')
    }
  }

  return (
    <Box className={`BtnSnapshot ${isFullScreen ? '' : 'n-fullScreen'}`} style={{ position: 'relative', marginLeft:'10px' }}>
      <MuiButton
        variant='text'
        color='light'
        onClick={() => snapshotActiveStateFunc()}
      >
        <IconLogoSnapshot />
      </MuiButton>
    </Box>
  )
}
